const q=(s,c=document)=>c?.querySelector(s),qa=(s,c=document)=>c?[...c.querySelectorAll(s)]:[];

// Quiet, dependency-free interaction sounds. Audio starts only after a user click.
let audioContext;
const playClickTone=primary=>{
  const AudioContext=window.AudioContext||window.webkitAudioContext;
  if(!AudioContext)return;
  audioContext??=new AudioContext();
  if(audioContext.state==='suspended')audioContext.resume();
  const now=audioContext.currentTime,osc=audioContext.createOscillator(),gain=audioContext.createGain();
  osc.type='sine';
  osc.frequency.setValueAtTime(primary?420:300,now);
  osc.frequency.exponentialRampToValueAtTime(primary?620:390,now+.055);
  gain.gain.setValueAtTime(.0001,now);
  gain.gain.exponentialRampToValueAtTime(primary ? .026 : .018,now+.008);
  gain.gain.exponentialRampToValueAtTime(.0001,now+.075);
  osc.connect(gain).connect(audioContext.destination);
  osc.start(now);osc.stop(now+.08);
};
const playSlideTone=()=>{
  const AudioContext=window.AudioContext||window.webkitAudioContext;
  if(!AudioContext)return;
  audioContext??=new AudioContext();
  if(audioContext.state==='suspended')audioContext.resume();
  const now=audioContext.currentTime,osc=audioContext.createOscillator(),gain=audioContext.createGain();
  osc.type='sine';
  osc.frequency.setValueAtTime(540,now);
  osc.frequency.exponentialRampToValueAtTime(430,now+.06);
  gain.gain.setValueAtTime(.0001,now);
  gain.gain.exponentialRampToValueAtTime(.014,now+.006);
  gain.gain.exponentialRampToValueAtTime(.0001,now+.07);
  osc.connect(gain).connect(audioContext.destination);
  osc.start(now);osc.stop(now+.075);
};
document.addEventListener('pointerdown',e=>{
  const button=e.target.closest('button');
  if(button&&!button.disabled&&!button.closest('[data-mobile-product-slider]'))playClickTone(button.classList.contains('btn'));
});

const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');observer.unobserve(e.target)}}),{threshold:.12}):null;
qa('.reveal').forEach(el=>observer?observer.observe(el):el.classList.add('visible'));

const nav=q('.nav'),menu=q('#menuBtn');
menu?.addEventListener('click',()=>{const open=nav.classList.toggle('open');menu.setAttribute('aria-expanded',open)});
qa('.nav a').forEach(a=>a.addEventListener('click',()=>nav.classList.remove('open')));

const checkout=q('#checkout');
qa('.buy-trigger').forEach(btn=>btn.addEventListener('click',()=>{document.body.append(Object.assign(document.createElement('div'),{className:'flash'}));checkout?.showModal()}));
q('.close',checkout)?.addEventListener('click',()=>checkout.close());
checkout?.addEventListener('click',e=>{if(e.target===checkout)checkout.close()});

const variantSelect=q('.variant-select',checkout);
variantSelect?.addEventListener('change',()=>{
  const option=variantSelect.selectedOptions[0],available=option?.dataset.available==='true';
  qa('[data-product-price]').forEach(el=>el.textContent=option.dataset.price);
  const stock=q('[data-stock]',checkout),submit=q('.checkout-action',checkout);
  if(stock)stock.textContent=available?'In stock':'Sold out';
  if(submit)submit.disabled=!available;
});

qa('details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)qa('details').filter(x=>x!==d).forEach(x=>x.open=false)}));

const reviewFab=q('#reviewFabToggle'),reviewPopover=q('#reviewPopover');
const setReviews=open=>{if(!reviewFab||!reviewPopover)return;reviewFab.checked=open;reviewPopover.classList.toggle('open',open);reviewPopover.setAttribute('aria-hidden',!open)};
const reviewsToggle=q('#reviewsToggle'),reviewsPanel=q('#reviewsPanel');
const setReviewsPanel=open=>{if(!reviewsToggle||!reviewsPanel)return;reviewsToggle.setAttribute('aria-expanded',open);reviewsPanel.hidden=!open};
reviewsToggle?.addEventListener('click',()=>setReviewsPanel(reviewsToggle.getAttribute('aria-expanded')!=='true'));
reviewPopover?.addEventListener('click',e=>e.stopPropagation());
q('#closeReviews')?.addEventListener('click',()=>setReviews(false));
q('#viewAllReviews')?.addEventListener('click',e=>{e.preventDefault();setReviews(false);setReviewsPanel(true);q('#reviews')?.scrollIntoView({behavior:'smooth',block:'start'})});
if(reviewFab){
  document.addEventListener('click',e=>{if(!e.target.closest('.floating-reviews'))setReviews(false)});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')setReviews(false)});
}

const mobileSlider=q('[data-mobile-product-slider]');
if(mobileSlider){
  const track=q('.mobile-product-track',mobileSlider),slides=qa('.mobile-product-slide',mobileSlider),dots=qa('[data-slide-to]',mobileSlider),counter=q('.mobile-slide-count',mobileSlider);
  let slideIndex=0,startX=null;
  const showSlide=next=>{
    slideIndex=(next+slides.length)%slides.length;
    track.style.transform=`translate3d(-${slideIndex*100}%,0,0)`;
    dots.forEach((dot,index)=>{
      const active=index===slideIndex;
      dot.classList.toggle('active',active);
      active?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current');
    });
    if(counter)counter.textContent=`${String(slideIndex+1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
    playSlideTone();
  };
  q('[data-slide-prev]',mobileSlider)?.addEventListener('click',()=>showSlide(slideIndex-1));
  q('[data-slide-next]',mobileSlider)?.addEventListener('click',()=>showSlide(slideIndex+1));
  dots.forEach(dot=>dot.addEventListener('click',()=>showSlide(Number(dot.dataset.slideTo))));
  mobileSlider.addEventListener('pointerdown',e=>{
    if(e.target.closest('button'))return;
    startX=e.clientX;
    mobileSlider.setPointerCapture?.(e.pointerId);
  });
  mobileSlider.addEventListener('pointerup',e=>{
    if(startX===null)return;
    const distance=e.clientX-startX;
    startX=null;
    if(Math.abs(distance)>42)showSlide(slideIndex+(distance<0?1:-1));
  });
  mobileSlider.addEventListener('pointercancel',()=>{startX=null});
  mobileSlider.addEventListener('keydown',e=>{
    if(e.key==='ArrowLeft')showSlide(slideIndex-1);
    if(e.key==='ArrowRight')showSlide(slideIndex+1);
  });
}

window.addEventListener('scroll',()=>{document.documentElement.style.setProperty('--drive',`${scrollY*.05}px`)},{passive:true});
